import get from 'lodash.get';

const getPricingUrl = (rootState) => get(rootState, 'user.partnerData.properties.pricingUrl', null);

export default getPricingUrl;
